import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import api from '../services/api'
import { useToast } from '../context/ToastContext'
import { useAuth } from '../context/AuthContext'
import { usePermisos } from '../hooks/usePermisos'
import { Ico, Boton } from './ui'
import { t, tx } from '../utils/i18n'   // B-2259 · los textos, en el idioma de quien mira (utils/i18n)

const POLL_MS = 15000  // cada 15s

// QUIEN VE ESTO. Los errores de envio son trabajo de RECEPCION: son recordatorios y documentos que
// no han salido y hay que reenviar o llamar. Hasta ahora se montaba en el Layout comun sin ninguna
// condicion, asi que un doctor o un colaborador se comia el badge rojo, el sonido y el modal
// automatico de un mensaje que no le toca a el — y aprendia a ignorarlo, que es lo peor que le
// puede pasar a un aviso.
//
// Se deja ANCHO a proposito (los tres roles que trabajan la bandeja de WhatsApp, mas superadmin):
// si esto se pasa de estricto, un recordatorio que no sale deja de avisar a NADIE y el paciente no
// se entera de su cita. Mejor que lo vea alguien de mas que nadie.
const ROLES_ENVIOS = ['admin', 'recepcion', 'auxiliar']

export default function AlertasEnvios() {
  const { user } = useAuth()
  // EL ESPEJO EXACTO DE `leToca` (backend/routes/conversaciones.js): `esAdmin(req) ||
  // ROLES_ENVIOS.includes(rol)`. Aqui ponia `user.es_superadmin === true || ...`, que es la copia
  // VIEJA —la que alli se corrigio— escrita en el navegador: medido por HTTP, un colaborador de
  // plataforma se lleva de `/api/conversaciones/errores-envio/:id/marcar-visto` el mismo 403 que su
  // companero de rol, y esta linea le montaba igualmente el badge rojo, el sonido y el modal
  // automatico de unos mensajes que no le tocan. La mitad de "administradora" la contesta el
  // servidor (`_es_admin`); la lista de roles sigue siendo la de la pantalla.
  const { esAdmin } = usePermisos()
  const leVaEsto = !!user && (esAdmin || ROLES_ENVIOS.includes(user.rol))
  const toast = useToast()
  const navigate = useNavigate()
  const [errores, setErrores] = useState([])
  const [modalOpen, setModalOpen] = useState(false)
  // EL BOTE DE «ESTO YA LO HE AVISADO» VA EN UN `ref`, NO EN ESTADO, Y ESA ES LA DIFERENCIA ENTRE
  // QUE EL BOTON FUNCIONE O NO. Estaba en `useState`, y el sondeo de cada 15 s vive dentro de un
  // `useEffect` cuyas dependencias son `[leVaEsto]`: `fetchErrores` se queda con el valor que tenia
  // `yaNotificados` EL DIA QUE SE MONTO LA PANTALLA —el conjunto vacio— para siempre. Consecuencia
  // medida: marcabas uno como visto, cerrabas el aviso, y quince segundos despues el modal se
  // volvia a abrir solo, con sonido, con los que quedaban; y otra vez a los treinta, y a los
  // cuarenta y cinco. Desde el mostrador eso es «he pulsado Marcar visto y no ha servido de nada».
  // Un `ref` lo lee y lo escribe el mismo objeto en cada vuelta, asi que lo avisado se queda avisado.
  const yaNotificados = useRef(null)
  if (yaNotificados.current === null) {
    try { yaNotificados.current = new Set(JSON.parse(sessionStorage.getItem('errores_envio_notificados') || '[]')) } catch { yaNotificados.current = new Set() }
  }
  const audioRef = useRef(null)

  useEffect(() => {
    audioRef.current = new Audio('/notif.mp3')
    audioRef.current.volume = 0.6
    
    const fetchErrores = async () => {
      try {
        const r = await api.get('/conversaciones/errores-envio')
        const list = r.data?.errores || []
        setErrores(list)
        
        // Notificar errores nuevos
        const nuevos = list.filter(e => !yaNotificados.current.has(e.id))
        // t515 · a quién le interrumpe lo decide la clínica (Notificaciones → Configurar, «Un mensaje automático no ha
        // salido»): la ventana, el sonido y el aviso del navegador. La lista y el número se ven igual. Sin `aviso` (un
        // servidor de antes), como siempre.
        const av = r.data?.aviso || {}
        if (nuevos.length > 0) {
          // Modal automático
          if (av.ventana !== false) setModalOpen(true)
          // Sonido
          if (av.sonido !== false) { try { audioRef.current?.play().catch(()=>{}) } catch {} }
          // Notificación del sistema vía SW
          if (av.push !== false && typeof Notification !== 'undefined' && Notification.permission === 'granted' && 'serviceWorker' in navigator) {
            navigator.serviceWorker.ready.then(reg => {
              reg.active?.postMessage({
                type: 'show-notification',
                titulo: nuevos.length + ' error' + (nuevos.length>1?'es':'') + ' de envío',
                body: 'Hay recordatorios que no se han podido enviar. Revisar.',
                conversacionId: 0,
                categoria: 'urgentes',
                msgId: 'err-' + Date.now()
              })
            })
          }
          // Marcar como notificados (sessionStorage para no spamear)
          for (const e of nuevos) yaNotificados.current.add(e.id)
          try { sessionStorage.setItem('errores_envio_notificados', JSON.stringify([...yaNotificados.current].slice(-200))) } catch { /* modo privado, cuota */ }
        }
      } catch(e) {
        if (e.response?.status !== 401) console.error('[AlertasEnvios] Error:', e.message)
      }
    }
    
    if (!leVaEsto) return   // ni una peticion cada 15 s para quien no puede hacer nada con esto
    fetchErrores()
    const intv = setInterval(fetchErrores, POLL_MS)
    return () => clearInterval(intv)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leVaEsto])

  // SI FALLA, SE DICE. Antes los dos catch eran console.error a secas: el servidor llevaba meses
  // devolviendo 500 en "marcar visto" (JSON mal armado) y en pantalla el boton solo parecia no
  // hacer nada. Un fallo mudo es un fallo que nadie reporta.
  const marcarVisto = async (id) => {
    try {
      await api.patch('/conversaciones/errores-envio/' + id + '/marcar-visto')
      // Y NO SE VUELVE A AVISAR DE ESTE. Sin esta linea, el sondeo siguiente lo trataria como
      // nuevo si el servidor lo devolviera otra vez, que es como se ha llegado hasta aqui.
      yaNotificados.current.add(id)
      setErrores(prev => {
        const quedan = prev.filter(e => e.id !== id)
        // Si era el ultimo, el aviso se va entero: dejar el modal abierto diciendo «No hay errores
        // pendientes» delante de quien acaba de despacharlos es pedirle un segundo clic para nada.
        if (quedan.length === 0) setModalOpen(false)
        return quedan
      })
    } catch(e) { toast.error(e.response?.data?.error || t('components.AlertasEnvios.no_se_ha_podido_marcar', 'No se ha podido marcar como visto.')) }
  }

  // B-045 · SOLO LOS QUE SE TIENEN DELANTE, Y SOLO PARA QUIEN PULSA. Se mandan los ids de la lista:
  // un error que llegue entre el ultimo sondeo y el clic no lo ha visto nadie, y no se marca.
  const marcarTodosVistos = async () => {
    const ids = errores.map(e => e.id)
    try {
      await api.patch('/conversaciones/errores-envio/marcar-todos-vistos', { ids })
      for (const id of ids) yaNotificados.current.add(id)
      setErrores([])
      setModalOpen(false)
    } catch(e) { toast.error(e.response?.data?.error || t('components.AlertasEnvios.no_se_han_podido_marcar', 'No se han podido marcar como vistos.')) }
  }

  // B-045 · «UN BOTON QUE LLEVE A DONDE ESTA EL PROBLEMA PARA SOLUCIONARLO». A donde, lo decide el
  // servidor (services/erroresEnvioDestino): la ficha si es el telefono, la cita si el envio era de
  // una cita, Automatismos si es la plantilla. Ir NO marca el aviso: se marca cuando se ha arreglado.
  const irAlProblema = (err) => {
    if (!err.ir || !err.ir.ruta) return
    setModalOpen(false)
    navigate(err.ir.ruta)
  }

  if (!leVaEsto) return null
  if (errores.length === 0 && !modalOpen) return null

  return (
    <>
      {/* Badge flotante abajo-derecha */}
      {errores.length > 0 && (
        <button
          onClick={() => setModalOpen(true)}
          className="parpadeo-aviso"
          // t340 · con LucIA en la esquina (más alta que el globo), index.css lo sube encima de ella.
          data-aviso-errores-envio=""
          style={{
            // B-645 · ENCIMA DEL CHAT Y DEL MISMO TAMAÑO. El dueño, 18-sep: «el icono de "Errores de envio"
            // debe igualarse en tamaño al del chat de soporte tecnico, ademas debe hacerse que cuando salga
            // el icono de errores de envio salga encima del icono de chat». Los dos vivian en la misma
            // esquina y se TAPABAN: el del chat (42 px, z 2000) se comia a este (56 px, z 1500), asi que el
            // aviso de que un mensaje no ha salido quedaba debajo del globo de ayuda. Ahora miden lo mismo
            // (52) y este se coloca JUSTO ENCIMA, en la misma columna: 16 de margen + 52 del chat + 10 de
            // aire = 78. Si se cambia el tamaño del chat, hay que cambiar esta cuenta (lo mide su guardia).
            position:'fixed', bottom: 'calc(78px + var(--sa-abajo))', right:'16px', zIndex:1500,
            background:'var(--danger)', color:'#fff', border:'none', borderRadius:'50%',
            width:'52px', height:'52px', fontSize:'22px', cursor:'pointer',
            boxShadow:'0 4px 14px color-mix(in srgb, var(--danger) 45%, transparent)',
            // LA ANIMACION NO EXISTIA. Aqui ponia `pulse-rojo`, que es el nombre de la CLASE de
            // index.css, no el de sus fotogramas (`pulseRojo`): el navegador no encuentra ninguna
            // animacion con ese nombre y no pasa nada — el globo de errores llevaba meses quieto.
            // Y `pulseRojo` tampoco vale aqui: anima el FONDO, y este boton ya es rojo entero, asi
            // que le borraria el suyo. Va por clase (no en linea) para que
            // `prefers-reduced-motion: reduce` pueda apagarlo: una animacion en linea gana siempre
            // a la regla del medio, y quien tiene el sistema en «menos movimiento» se la comeria.
            display:'flex', alignItems:'center', justifyContent:'center'
          }}
          title={t('components.AlertasEnvios.error_es_de_envio', '{{n}} error(es) de envío', { n: errores.length })}>
          <span style={{position:'relative', display:'flex'}}>
            <Ico n="warn" s={24} />
            <span style={{
              position:'absolute', top:'-8px', right:'-12px',
              background:'var(--surface)', color:'var(--danger)', borderRadius:'10px',
              fontSize:'11px', fontWeight:800, padding:'2px 6px', minWidth:'18px',
              boxShadow:'var(--shadow-sm)'
            }}>{errores.length}</span>
          </span>
        </button>
      )}

      {modalOpen && (
        <div className="modal-safe" style={{position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', zIndex:2500, display:'flex', alignItems:'center', justifyContent:'center', padding:'20px'}}
          onClick={e => e.stopPropagation()}>
          <div style={{background:'var(--surface)', borderRadius:'16px', maxWidth:'700px', width:'100%', maxHeight:'calc(85vh / var(--z, 1))', display:'flex', flexDirection:'column', overflow:'hidden', boxShadow:'0 24px 70px rgba(0,0,0,0.30)', border:'1px solid var(--border)'}}>
            <div style={{padding:'16px 22px', borderBottom:'1px solid var(--border)', background:'var(--danger-bg)', display:'flex', justifyContent:'space-between', alignItems:'center', gap:'10px'}}>
              <div style={{display:'flex', alignItems:'center', gap:'11px', minWidth:0}}>
                <span style={{width:'38px', height:'38px', borderRadius:'11px', flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center', background:'color-mix(in srgb, var(--danger) 16%, transparent)', color:'var(--danger)'}}>
                  <Ico n="bell" s={19} />
                </span>
                <div style={{minWidth:0}}>
                  <div style={{fontSize:'16px', fontWeight:800, color:'var(--danger)'}}><span style={{display:'inline-flex', alignItems:'center', gap:'6px'}}><Ico n="warn" s={16} />{t('components.AlertasEnvios.errores_de_envio', ' Errores de envío')}</span></div>
                  <div style={{fontSize:'12px', color:'var(--text-muted)', marginTop:'2px'}}>{tx('components.AlertasEnvios.envio_s_fallidos_en_los', '{{length}} envío(s) fallidos en los últimos 7 días. «Marcar visto» solo lo quita de tu lista: el resto del equipo lo sigue viendo.', { length: errores.length })}</div>
                </div>
              </div>
              <button onClick={() => setModalOpen(false)} title={t('components.AlertasEnvios.cerrar', 'Cerrar')} style={{background:'var(--surface-2)', border:'1px solid var(--border)', color:'var(--text-secondary)', borderRadius:'50%', width:'32px', height:'32px', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', flexShrink:0}}>
                <Ico n="close" s={16} />
              </button>
            </div>

            <div style={{flex:1, overflowY:'auto', padding:'16px', background:'var(--surface-2)'}}>
              {errores.length === 0 && <div style={{textAlign:'center', padding:'40px', color:'var(--text-muted)'}}>{t('components.AlertasEnvios.no_hay_errores_pendientes', 'No hay errores pendientes')}</div>}
              {errores.map(err => (
                <div key={err.id} style={{padding:'14px', border:'1px solid color-mix(in srgb, var(--danger) 30%, var(--border))', borderRadius:'12px', background:'var(--surface)', marginBottom:'10px', boxShadow:'var(--shadow-sm)'}}>
                  <div style={{display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:'10px', marginBottom:'6px', flexWrap:'wrap'}}>
                    <div style={{minWidth:0}}>
                      <div style={{fontSize:'13px', fontWeight:800, color:'var(--text-primary)'}}>
                        {err.paciente_nombre || t('components.AlertasEnvios.desconocido', 'Desconocido')} {err.paciente_apellidos || ''}
                      </div>
                      <div style={{fontSize:'11px', color:'var(--text-muted)'}}><span style={{display:'inline-flex', alignItems:'center', gap:'5px'}}><Ico n="phone" s={12} /> {err.tel_movil || t('components.AlertasEnvios.sin_telefono', 'sin teléfono')}</span></div>
                    </div>
                    <div style={{display:'flex', gap:'6px', flexWrap:'wrap', justifyContent:'flex-end'}}>
                      {err.ir && err.ir.ruta && (
                        <button type="button" onClick={() => irAlProblema(err)} style={{display:'inline-flex', alignItems:'center', gap:'5px', padding:'5px 10px', background:'var(--danger)', border:'1px solid var(--danger)', color:'#fff', borderRadius:'8px', fontSize:'11px', fontWeight:700, cursor:'pointer', whiteSpace:'nowrap', flexShrink:0}}>
                          <Ico n="arrow" s={13} /> {err.ir.rotulo}
                        </button>
                      )}
                      <button type="button" onClick={() => marcarVisto(err.id)} style={{display:'inline-flex', alignItems:'center', gap:'5px', padding:'5px 10px', background:'var(--surface)', border:'1px solid var(--border)', color:'var(--text-secondary)', borderRadius:'8px', fontSize:'11px', fontWeight:700, cursor:'pointer', whiteSpace:'nowrap', flexShrink:0}}>
                        <Ico n="check" s={13} />{t('components.AlertasEnvios.marcar_visto', ' Marcar visto')}
                      </button>
                    </div>
                  </div>
                  <div style={{fontSize:'11px', color:'var(--text-muted)', marginBottom:'4px', display:'flex', alignItems:'center', gap:'5px'}}>
                    <Ico n="calendar" s={12} /> {new Date(err.ejecutado_at).toLocaleString('es-ES')}
                  </div>
                  <div style={{fontSize:'11px', color:'var(--text-muted)', marginBottom:'4px', display:'flex', alignItems:'center', gap:'5px'}}>
                    <Ico n="bot" s={12} /> <span>{t('components.AlertasEnvios.automatismo', 'Automatismo: ')}<strong style={{color:'var(--text-secondary)'}}>{err.automatismo_nombre}</strong></span>
                  </div>
                  <div style={{fontSize:'12px', color:'var(--danger)', background:'var(--danger-bg)', border:'1px solid color-mix(in srgb, var(--danger) 22%, var(--border))', padding:'8px 10px', borderRadius:'8px', marginTop:'6px', fontFamily:'monospace', wordBreak:'break-word'}}>
                    {err.error_msg || err.mensaje_enviado || t('components.AlertasEnvios.sin_detalles', 'Sin detalles')}
                  </div>
                  {err.ir_nota && (
                    <div style={{fontSize:'12px', color:'var(--text-secondary)', marginTop:'6px', display:'flex', alignItems:'center', gap:'5px'}}>
                      <Ico n="info" s={12} /> <span>{err.ir_nota}</span>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {errores.length > 0 && (
              <div style={{padding:'12px 20px', borderTop:'1px solid var(--border)', background:'var(--surface)', display:'flex', gap:'8px', justifyContent:'space-between', flexWrap:'wrap'}}>
                <Boton variante="peligro" icon="checkCircle" onClick={marcarTodosVistos}>
                  {t('components.AlertasEnvios.marcar_todos_como_vistos', 'Marcar todos como vistos')}
                </Boton>
                <Boton variante="suave" onClick={() => setModalOpen(false)}>
                  {t('components.AlertasEnvios.cerrar', 'Cerrar')}
                </Boton>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  )
}
